module.exports = __webpack_public_path__ + "img/5.4c0ffc93.png";